import {TrainingModalWindow} from './TrainingModalWindow';
export default TrainingModalWindow;
